import React from 'react';
import styles from './index.module.scss';
import { formatBoldTextHTML } from '../../../../utils/formatBoldText';

const PostDescriptionV1 = ({ contentText, contentTag, contentName }) => {
  if (!contentText || contentText === 'none') {
    return null;
  }

  return (
    <div className={styles.postDescriptionV1}>
      <div className={styles.contentText}>
        {contentText?.split('\n').map((line, lineIndex) => {
          const formattedLine = formatBoldTextHTML(line);
          return (
            <p
              key={lineIndex}
              dangerouslySetInnerHTML={{ __html: formattedLine }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PostDescriptionV1;
